import { useCallback } from 'react';
import { AnalyticsBrowser, UserTraits } from '@segment/analytics-next';

import { getCookiebotConsent } from 'app/shared/utils/useCookiebotConsent';
import { User } from 'app/shared/typings';

export const useSegmentIdentify = (analytics: AnalyticsBrowser) => {
  return useCallback(
    (user?: User | null, identifyTraits: UserTraits = {}) => {
      const cookieConsent = getCookiebotConsent();

      if (user) {
        const { id, firstName, lastName, email, brazeExternalId } = user;

        const name =
          firstName && lastName ? `${firstName} ${lastName}` : undefined;

        analytics?.identify?.(
          id.toString(),
          {
            source: 'client',
            visitor_type: 'fan',
            name,
            email,
            ...(brazeExternalId && { braze_external_id: brazeExternalId }),
            ...identifyTraits,
          },
          {
            consent: {
              categoryPreferences: {
                necessary: cookieConsent.necessaryConsent,
                preferences: cookieConsent.preferencesConsent,
                statistics: cookieConsent.statisticsConsent,
                marketing: cookieConsent.marketingConsent,
              },
            },
          }
        );
      }
    },
    [analytics]
  );
};
